import React, { useState, useEffect, useRef } from "react";
import queryString from 'query-string';
import { useLocation } from "react-router-dom";
import io from 'socket.io-client';
import TextContainer from '../TextContainer/TextContainer';
import Messages from '../Messages/Messages';
import InfoBar from '../Infobar/Infobar';
import Input from '../Input/Input';
import './Chat.css';

const Chat = () => {
  const location = useLocation();
  const [name, setName] = useState('');
  const [room, setRoom] = useState('');
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const socketRef = useRef(null);
  const ENDPOINT = 'https://real-time-webchat.onrender.com/';

  useEffect(() => {
    const { name, room } = queryString.parse(location.search);

    socketRef.current = io(ENDPOINT);

    setRoom(room);
    setName(name);

    socketRef.current.emit('join', { name, room }, (error) => {
      if (error) {
        alert(error);
      }
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [ENDPOINT, location.search]);

  useEffect(() => {
    socketRef.current.on('message', message => {
      setMessages(messages => [ ...messages, message ]);
    });

    socketRef.current.on("roomData", ({ users }) => {
      setUsers(users);
    });
  }, []);

  const sendMessage = (event) => {
    event.preventDefault();

    if (message.trim()) {
      socketRef.current.emit('sendMessage', message, () => setMessage(''));
    }
  };

  return (
    <div className="outerContainer">
      <div className="container">
        <InfoBar room={room} />
        <Messages messages={messages} name={name} />
        <Input message={message} setMessage={setMessage} sendMessage={sendMessage} />
      </div>
      <TextContainer users={users} />
    </div>
  );
};

export default Chat;
